// Module
var code = `<div class="form-group {{form.htmlClass}}" ng-class="{'has-error': hasError()}">
    <label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">{{form.title}}</label>

    <div class="dropdown {{form.fieldHtmlClass}}">
        <a class="dropdown-toggle" id="{{form.uuid}}" role="button" data-toggle="dropdown" data-target="#" href="#">
            <div class="input-group">
                <input sf-field-model="replaceAll"
                       type="text"
                       class="form-control"
                       placeholder="{{form.placeholder}}"
                       data-ng-model="\$\$value\$\$"
                />
                <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span>
            </div>
        </a>
        <ul class="dropdown-menu" role="menu" aria-labelledby="dLabel">
            <datetimepicker sf-field-model="replaceAll"
                            data-ng-model="\$\$value\$\$"
                            data-datetimepicker-config="{
                                dropdownSelector: '#' + form.uuid,
                                minView: 'day',
                                modelType: 'YYYY-MM-DD'
                            }"/>
        </ul>
    </div>
    <span class="help-block" sf-message="form.description"></span>
</div>
`;
// Exports
module.exports = code;